module.exports = __webpack_public_path__ + "media/images/bizzly-logo-87da3b9751afa56b14418a36ecd8c202.png";